var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPvpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.078 0.75C25.7253 0.75 26.25 1.27469 26.25 1.92192V7.28809C26.25 7.97431 25.9493 8.62601 25.4271 9.07134L6.75841 24.9933C6.48517 25.2264 6.11881 25.321 5.78365 25.1919C5.22556 24.9772 4.3106 24.5194 3.39565 23.6045C2.48067 22.6896 2.02286 21.7747 1.80806 21.2167C1.67906 20.8815 1.77363 20.5153 2.00666 20.242L17.93 1.5729C18.3754 1.05076 19.0272 0.75 19.7135 0.75H25.078Z",
    fill: "#F1564C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3751 14.827L25.9933 20.242C26.2264 20.5153 26.3209 20.8815 26.1919 21.2167C25.9771 21.7747 25.5193 22.6896 24.6043 23.6045C23.6894 24.5194 22.7744 24.9772 22.2164 25.1919C21.8812 25.321 21.5148 25.2264 21.2416 24.9933L15.3481 19.9667L21.3751 14.827ZM8.28652 0.75C8.9728 0.75 9.62461 1.05076 10.07 1.5729L12.8497 4.83217L6.42892 12.3607L2.57287 9.07134C2.08555 8.6557 1.79108 8.06028 1.75399 7.42482L1.75 7.28809V1.92192C1.75 1.27469 2.27471 0.75 2.92202 0.75H8.28652Z",
    fill: "#FDBB53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0705 17.9878L25.9933 20.2421C26.2264 20.5153 26.3209 20.8816 26.1919 21.2167C25.9771 21.7748 25.5193 22.6896 24.6043 23.6045C23.6894 24.5194 22.7744 24.9772 22.2163 25.192C21.8812 25.321 21.5148 25.2264 21.2416 24.9934L18.8628 22.9651C20.1995 21.6955 21.9354 20.0364 24.0705 17.9878Z",
    fill: "#FC8B46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9804 23.2718L24.0848 14.8795C24.3086 14.6477 24.6778 14.6413 24.9096 14.8651L25.7488 15.6755C26.4441 16.3469 26.4634 17.4548 25.792 18.15L19.3085 24.8639C18.6372 25.5591 17.5293 25.5784 16.834 24.9071L15.9948 24.0966C15.7631 23.8728 15.7566 23.5035 15.9804 23.2718Z",
    fill: "#FDBB53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95733 17.9536L9.04633 23.042L6.75842 24.9933C6.48517 25.2263 6.11882 25.3209 5.78365 25.1919C5.22556 24.9771 4.3106 24.5193 3.39565 23.6044C2.48067 22.6895 2.02286 21.7747 1.80806 21.2166C1.67906 20.8815 1.77363 20.5152 2.00666 20.242L3.95733 17.9536Z",
    fill: "#BB3333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 13L6.41699 20.5833",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0699 23.1788L3.82036 14.9293C3.59256 14.7014 3.22321 14.7014 2.99541 14.9293L2.17045 15.7542C1.48703 16.4376 1.48703 17.5457 2.17045 18.2291L8.77011 24.8287C9.45353 25.5122 10.5616 25.5122 11.245 24.8287L12.0699 24.0038C12.2977 23.776 12.2977 23.4066 12.0699 23.1788Z",
    fill: "#F1564C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvpIcon);
export default __webpack_public_path__ + "static/media/pvp_icon.8cd4def63be92cfce6fae206efbcb050.svg";
export { ForwardRef as ReactComponent };